"use client";

import { $createMentionNode } from "./MentionNode";
import { generateObjectId } from "./scriptUtils";

const OBJECT_ID_RE = /^[a-f0-9]{24}$/;

/**
 * Rebuilds a MentionNode from a parsed notation object (the `{…json}` payload
 * produced by MentionNode.getSerializedData). Used by the initial parse
 * (InitializationPlugin) when seeding the editor from a notation string.
 *
 * The `character` branch is the *script* editor's speech notation (see
 * `shared/src/scriptNotation.ts`), not an artifact reference — a character
 * artifact arrives as `type: 'artifact'` with `scope: 'character'`.
 */
export function $createMentionNodeFromData(data) {
  const {
    id: rawId,
    type,
    characterId,
    artifactId,
    assetId,
    name,
    checksum,
    ...rest
  } = data;
  const objectId =
    typeof rawId === "string" && OBJECT_ID_RE.test(rawId)
      ? rawId
      : generateObjectId();

  let mentionType, mentionId, mentionName;
  if (type === "character") {
    mentionType = "character";
    mentionId = characterId;
    mentionName = "";
  } else if (type === "artifact") {
    mentionType = "artifact";
    mentionId = artifactId;
    mentionName = name || "Artifact";
  } else if (type === "asset") {
    mentionType = "asset";
    mentionId = assetId;
    mentionName = name || "Asset";
  } else {
    mentionType = "command";
    mentionId = type;
    mentionName = String(type).charAt(0).toUpperCase() + String(type).slice(1);
  }

  return $createMentionNode(
    mentionType,
    mentionId,
    mentionName,
    rest,
    objectId,
  );
}
